// extracted by mini-css-extract-plugin
module.exports = {"tablet-landscape-up":"(min-width: calc(1024 * 1px))","header":"Report_header__1BfMX"};